export const URL_ITEMS = [
  { id: 1, content: '카카오톡 공유' },
  { id: 2, content: 'URL 공유' },
];
